import { render, staticRenderFns } from "./RedeemIntegration.vue?vue&type=template&id=346b34b2"
import script from "./RedeemIntegration.vue?vue&type=script&lang=js"
export * from "./RedeemIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports